/**
 * Category registration index — ONE line per category (01-architecture.md §4).
 * Adding a category: create its folder with schema.ts, register it here, add its geometry
 * module to bim-geometry's registry index, optionally a handle config in the app.
 */
import { registerCategory } from '../registry'
import { wallSchema } from './wall/schema'
import { floorSchema } from './floor/schema'
import { ceilingSchema } from './ceiling/schema'
import { doorSchema } from './door/schema'
import { windowSchema } from './window/schema'
import { roofSchema } from './roof/schema'
import { stairSchema } from './stair/schema'
import { rampSchema } from './ramp/schema'
import { railingSchema } from './railing/schema'
import { fenceSchema } from './fence/schema'
import { caseworkSchema } from './casework/schema'
import { objectSchema } from './object/schema'
import { fixtureSchema } from './fixture/schema'
import { columnSchema } from './column/schema'
import { beamSchema } from './beam/schema'
import { topoSchema } from './topo/schema'
import { bodySchema } from './body/schema'
import { footingSchema } from './footing/schema'
import { stemSchema } from './stem/schema'
import { poolSchema } from './pool/schema'
import { vineSchema } from './vine/schema'
import { downspoutSchema } from './downspout/schema'
import { nicheSchema } from './niche/schema'
import { awningSchema } from './awning/schema'
import { cupolaSchema } from './cupola/schema'
import { pavingSchema } from './paving/schema'

registerCategory(wallSchema)
registerCategory(floorSchema)
registerCategory(ceilingSchema)
registerCategory(doorSchema)
registerCategory(windowSchema)
registerCategory(roofSchema)
registerCategory(stairSchema)
registerCategory(rampSchema)
registerCategory(railingSchema)
registerCategory(fenceSchema)
registerCategory(caseworkSchema)
registerCategory(objectSchema)
registerCategory(fixtureSchema)
registerCategory(columnSchema)
registerCategory(beamSchema)
registerCategory(topoSchema)
// FACE-EDGE KERNEL K1 (docs/bim-plan/21): SketchUp-true free geometry
registerCategory(bodySchema)
// FOOTINGS round: type-only families (no elements, no draw tools) — registered so the
// library editors, firm-library sync, and typeRef resolution see their schemas
registerCategory(footingSchema)
registerCategory(stemSchema)
// POOL DESIGNER round (2026-10-02)
registerCategory(poolSchema)
// DOWNSPOUTS (2026-10-04)
registerCategory(downspoutSchema)
// VINES (2026-10-05)
registerCategory(vineSchema)
// WALL NICHE (2026-10-07)
registerCategory(nicheSchema)
// AWNINGS (2026-10-08)
registerCategory(awningSchema)
registerCategory(cupolaSchema)
// PAVING (2026-10-08)
registerCategory(pavingSchema)
